export const BOOKING_TYPES = {
  BOOKING_INQUIRY: 'BOOKING_INQUIRY',
  BOOKING_REQUEST: 'BOOKING_REQUEST',
  INSTANT_BOOKING: 'INSTANT_BOOKING',
} as const;

export type BookingType = (typeof BOOKING_TYPES)[keyof typeof BOOKING_TYPES];
